import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';

type Props = {
  skip?: number;
  limit?: number;
};

export const getQuestions = async (skip?: number, limit?: number) => {
  try {
    let response;
    if (skip !== undefined && limit !== undefined) {
      response = await Axios.get(`/questions/list?skip=${skip}&limit=${limit}`);
    } else {
      response = await Axios.get(`/questions/list`);
    }
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetQuestions = ({ limit, skip }: Props = {}) => {
  console.log('limit', limit, 'skip', skip, 'useGetQuestions');
  const questions = useQuery({
    queryKey: ['get_predefined_question', skip, limit],
    queryFn: () => getQuestions(skip, limit),
  });

  return questions;
};
